import {
  SoftwarePackageDeploymentRing,
  SoftwarePackageVersion
} from "@libs/api/gateways/field/field-ops-gateway.dtos";

export interface DeploymentRingResultantVersion
  extends SoftwarePackageDeploymentRing {
  isLatest: boolean;
}

export const getLatestSoftwarePackageVersion = (
  softwarePackageVersions: SoftwarePackageVersion[]
): SoftwarePackageVersion | undefined =>
  softwarePackageVersions.reduce<SoftwarePackageVersion | undefined>(
    (latest, current) =>
      !latest || current.datePublishedUtc > latest.datePublishedUtc
        ? current
        : latest,
    undefined
  );

export const getDeploymentRingResultantVersions = (
  deploymentRings: SoftwarePackageDeploymentRing[],
  softwarePackageVersions: SoftwarePackageVersion[]
): DeploymentRingResultantVersion[] => {
  const latestVersion = getLatestSoftwarePackageVersion(
    softwarePackageVersions
  );

  return deploymentRings.map(deploymentRing => ({
    ...deploymentRing,
    isLatest:
      !!deploymentRing.softwarePackageVersionId &&
      deploymentRing.softwarePackageVersionId === latestVersion?.id
  }));
};
